{"program":"usda","format":"percent","annual":0.35,"upfront":1.0,"modifierLabels":{}}